module.exports = __webpack_public_path__ + "static/img/1-1.c283c35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/1-1.png
// module id = 0o/c
// module chunks = 0